import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { Link } from "react-router";
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import Decoder from "../../../Token/Decoder";
import Token from "../../../Token/Token";
import SignupActions from "../../../Action/Actions/SignupActions";

class CheckEmail extends Component {
  constructor(public props) {
    super(props);
  }

  public state = {
    email: "",
    showEmail: true
  };

  public componentWillMount = () => {
    const storageToken = Token.getInstant() && Decoder.decode(Token.getInstant());

    // If we are already logged in, ignore this page.
    if (!!storageToken && !storageToken.isExpired && this.props.app.loadedEntities.length > 0) {
      return this.redirect("/app/dashboard/overview");
    }
  }

    /**
   * This is the hotfix for react-router issue, that cause the problem of
   * infinite rerendering of component: routeParams(received for react-router Route) props
   * updates few times per sec
   * 
   * TODO: Should be fixed by installing the new version of react-router-dom
   * */ 
     shouldComponentUpdate(newProps, nextState) {
      if (this.state !== nextState) return true;
      const isPropsStringsSame = JSON.stringify(newProps) === JSON.stringify(this.props)
      if (
        isPropsStringsSame
        && newProps.routeParams !== this.props.routeParams
      ) {
        return false;
      }
  
      return !isPropsStringsSame;
    }

  public componentWillUnmount = () => {
    this.props.dispatch({
      type: Constants.PAGE_CHECK_EMAIL_CLEAR
    })
  }

  protected process = () => {
    this.props.dispatch({
      type: Constants.PAGE_CHECK_EMAIL_START,
      payload: {
        email: this.state.email
      }
    });
  }

  protected updateEmail = (e) => {
    this.setState({
      email: e.target.value
    })

    this.props.dispatch(SignupActions.updateEmail(e.target.value));
  }

  protected onEnter = (event): any =>{
    if (event.key === "Enter") {
      return this.process();
    }
  }

  public render() {
    return (
      <div className="state-auth">
        <div className="box component-check-email">

          {this.props.component.signoutReason.length > 0 && <p>{this.props.component.signoutReason}</p>}

          <h1>Casadesk</h1>
          <h2>{this.trans("title-signin")}</h2>

          <form onSubmit={e => e.preventDefault()} autoComplete="on">
            <TextField
              autoFocus={true}
              className="form-element"
              label={this.trans("label-email")}
              type="email"
              autoComplete="email"
              fullWidth={true}
              value={this.state.email}
              onKeyPress={this.onEnter}
              onChange={this.updateEmail}
              variant="standard"
              error={!!this.props.component.message}
            />
            {!!this.props.component.message && <FormHelperText id="component-error-text">{this.props.component.message}</FormHelperText>}

            <TextField
              style={{position: "absolute", top: "-9999px", left: "-9999px"}}
              className="form-element"
              label={this.trans("label-password")}
              type="password"
              autoComplete="password"
              error={false}
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              onClick={this.process}
              disabled={this.props.component.isFetching}
              style={{ margin: "20px 0" }}
            >
              {this.props.component.isFetching === true ? this.trans("button-please-wait") : this.trans("button-next")}
            </Button>

            <Link to="/auth/signup">
              {this.trans("link-signup")}
            </Link>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.checkEmail,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  CheckEmail
);
